import PropTypes from 'prop-types';

import useRequest from 'core/hooks/useRequest';
import { menuQuery } from 'core/queries/menu';

import { VOID_QUERY } from 'core/site/constants';


/**
 * @author Alexey Rezakov <a.rezakov@rambler-co.ru>
 */
export default function withMenu(menuSlug) {
  return function menuHOC(Component) {
    function MenuProvider(props) {
      const queryParams = props.menu
        ? VOID_QUERY
        : menuQuery({ menu_slug: menuSlug });
      const {
        data = props.menu,
      } = useRequest(queryParams);

      return <Component {...props} menu={data || {}} />;
    }

    MenuProvider.propTypes = { menu: PropTypes.any };

    return MenuProvider;
  };
}
